import './style.css';

import React, { Component } from 'react';

import PropTypes from 'prop-types';
import spriteNav from '../../Assets/school-sprites.png'

export default class HeaderButton extends Component {

    render() {
        return (
        <div
            className="hsg-header-btn-root left" 
            onClick={() => {this.props.onClick()}}>

            <div className={"hsg-header-btn-icon" + (this.props.selected ? " hsg-header-btn-icon-selected" : "")}>
                {/* <i className={this.props.glyph} /> */}
                <div style = {this.getStyle()}></div>
            </div>


            <p className={"hsg-header-btn-text" + (this.props.selected ? " hsg-header-btn-text-selected" : "")}>
                {this.props.text}
            </p>


            {/* {this.props.selected && <div className="hsg-header-btn-underline"></div>} */}

        </div>);
    }

    getStyle() {
        const style = {
            display: 'inline-block',
        };

        switch(this.props.glyph) {
            case 'dashboard':
                style.background = 'url(' + spriteNav + ') ' + (this.props.selected ? '-168px -10px' : '-125px -10px');
                style.width = '24px';
                style.height = '24px';
                break;
            
            case 'list':
                style.background = 'url(' + spriteNav + ') ' + (this.props.selected ? ' -299px -10px' : '-254px -10px');
                style.width = '24px';
                style.height = '24px';
                break;                
            
            case 'infirmary':
                style.background = 'url(' + spriteNav + ') ' + (this.props.selected ? ' -82px -10px' : '-211px -10px');
                style.width = '24px';
                style.height = '24px';
                break;

            case 'locker':
                style.background = 'url(' + spriteNav + ') ' + (this.props.selected ? ' -46px -10px' : '-10px -10px');
                style.width = '24px';
                style.height = '24px';
                
            }
            
        return style;
    }

}



HeaderButton.propTypes = {
    text: PropTypes.string.isRequired,
    glyph: PropTypes.string.isRequired,
    selected: PropTypes.bool,

    onClick: PropTypes.func.isRequired
};


// WEBPACK FOOTER //
// ./src/Components/HeaderButton/index.js